import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { PatientControllerApi } from "../services";
import { PatientDetails } from "../types/patient-types";
import { getConfigObject } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useGetPatient = (
  uuid?: string,
  disabled?: boolean
): UseQueryResult<PatientDetails | undefined, AxiosError> =>
  useQuery({
    queryKey: ["patient", uuid],
    enabled: !!uuid && !disabled,
    refetchOnWindowFocus: false,
    retry: (failCount) => failCount < 2,
    queryFn: async () =>
      new PatientControllerApi(getConfigObject())
        .getPatientById1(uuid as string)
        .then((res) => res?.data?.data as PatientDetails | undefined),
  });
